// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExtractIPsButton_extractButton__eUpc- {

    margin-top: 1.8rem;
    padding: 0.5rem 1.8rem;
    font-weight: 600;
    font-size: 1rem;
    color: #50fa7b;
    background: transparent;
    border: 2px solid #50fa7b;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: background-color 0.25s ease, color 0.25s ease, transform 0.15s ease;

}

.ExtractIPsButton_extractButton__eUpc-:hover {
    background-color: #50fa7b;
    color: #282a36;
    transform: scale(1.05);
}

.ExtractIPsButton_extractButton__eUpc-:active {
    transform: scale(0.95);
}

.ExtractIPsButton_extractButton__eUpc- {
    /* Deine bestehenden Styles */
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 120px;
    cursor: pointer;
}

.ExtractIPsButton_extractButton__eUpc-:disabled {
    cursor: not-allowed;
    opacity: 0.8;
}

.ExtractIPsButton_loaderContainer__6ef5L {
    display: flex;
    align-items: center;
    gap: 8px;
}

.ExtractIPsButton_spinner__BmQaK {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: ExtractIPsButton_spin__vrYw4 0.8s linear infinite;
}

@keyframes ExtractIPsButton_spin__vrYw4 {
    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ExtractIPsButton.module.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,+EAA+E;;AAEnF;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,sBAAsB;IACtB,4DAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".extractButton {\n\n    margin-top: 1.8rem;\n    padding: 0.5rem 1.8rem;\n    font-weight: 600;\n    font-size: 1rem;\n    color: #50fa7b;\n    background: transparent;\n    border: 2px solid #50fa7b;\n    border-radius: 0.5rem;\n    cursor: pointer;\n    transition: background-color 0.25s ease, color 0.25s ease, transform 0.15s ease;\n\n}\n\n.extractButton:hover {\n    background-color: #50fa7b;\n    color: #282a36;\n    transform: scale(1.05);\n}\n\n.extractButton:active {\n    transform: scale(0.95);\n}\n\n.extractButton {\n    /* Deine bestehenden Styles */\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 120px;\n    cursor: pointer;\n}\n\n.extractButton:disabled {\n    cursor: not-allowed;\n    opacity: 0.8;\n}\n\n.loaderContainer {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.spinner {\n    width: 14px;\n    height: 14px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-radius: 50%;\n    border-top-color: #fff;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extractButton": `ExtractIPsButton_extractButton__eUpc-`,
	"loaderContainer": `ExtractIPsButton_loaderContainer__6ef5L`,
	"spinner": `ExtractIPsButton_spinner__BmQaK`,
	"spin": `ExtractIPsButton_spin__vrYw4`
};
export default ___CSS_LOADER_EXPORT___;
